import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogTitle, IconButton, useMediaQuery, useTheme } from '@mui/material';

export function BaseDialog({ open, onClose, children, title, width = 350, ...props }) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            fullScreen={isSmallScreen}
            open={open}
            onClose={onClose}
            disableEnforceFocus
            disableAutoFocus
            disableRestoreFocus
            sx={{
                '& .MuiDialog-paper': {
                    width: isSmallScreen ? '100%' : width,
                    borderRadius: 4,
                },
            }}
            {...props}
        >
            <DialogTitle>
                {title}
                <IconButton
                    onClick={onClose}
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            {children}
        </Dialog>
    );
};
